<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              
              <a-col :md="12" :lg="10" :xxl="8" :sm="24">
                <a-form-item label="UDI编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入UDI编码" v-model="queryParam.productDi"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :lg="10" :xxl="8" :sm="24">
                <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称" v-model="queryParam.productName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :lg="10" :xxl="8" :sm="24">
                <a-form-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入规格型号" v-model="queryParam.specificationModel"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="发布日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width:100%"
                    v-model="queryParam.releaseTime"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onDateChange"
                    @ok="onDateOk"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="申报状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择申报状态" showSearch optionFilterProp="children" v-model="queryParam.declareStatus">
                    <a-select-option v-for="(item,index) in declareArr" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="申报状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择申报状态" v-model="queryParam.declareStatus">
                    <a-select-option value=0>未申报</a-select-option>
                    <a-select-option value=1>已填报</a-select-option>
                    <a-select-option value=2>已提交</a-select-option>
                    <a-select-option value=3>已提交</a-select-option>
                    <a-select-option value=-1>资料未完善</a-select-option>
                    <a-select-option value=-2>不允许申报</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <!-- <a-col :md="12" :lg="10" :xxl="8" :sm="24">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品标识体系编码名称">

                <a-select style="width:90%;" showSearch optionFilterProp="children" v-model="queryParam.codeSystem" :allowClear="true">
                  <a-select-option v-for="(item,index) in matype" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              </a-col> -->
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a> -->
                </a-col>
              </span>
              <!-- <template v-if="toggleSearchStatus">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="会员卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择会员卡号" showSearch optionFilterProp="children" v-model="queryParam.organId">
                      <a-select-option v-for="(item,index) in retailList" :key="index" :value="item.id">
                        {{ item.supplier }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="仓库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择仓库" showSearch optionFilterProp="children" v-model="queryParam.depotId">
                      <a-select-option v-for="(depot,index) in depotList" :value="depot.id">
                        {{ depot.depotName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择操作员" showSearch optionFilterProp="children" v-model="queryParam.creator">
                      <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                        {{ item.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="结算账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择结算账户" showSearch optionFilterProp="children" v-model="queryParam.accountId">
                      <a-select-option v-for="(item,index) in accountList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择单据状态" v-model="queryParam.status">
                      <a-select-option value="0">未审核</a-select-option>
                      <a-select-option value="1">已审核</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据备注" v-model="queryParam.remark"></a-input>
                  </a-form-item>
                </a-col>
              </template> -->
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button @click="myHandleAddDI" type="primary">注册产品DI</a-button>
          <a-button @click="asyncDiInfo" type="primary">同步数据</a-button>
          <!-- <a-button @click="myHandleAdd" type="primary">批量导入DI</a-button>-->
          <!-- <a-button @click="downloadModule" type="primary">下载导入模版</a-button> -->
          <a-button @click="downloadIntro" type="primary">下载导入说明</a-button>
          <a-button @click="handleImportXls" type="primary">导入</a-button>
          <a-button @click="handleDeleteBatch" type="primary">批量删除</a-button>
         <a-button @click="downloadDIs" type="primary">导出产品DI</a-button>
           <!--<a-button @click="myHandleAdd" type="primary">同步产品</a-button> -->
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" :rowKey="(record,index)=>{return record.id||index}"
                   bordered :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
                   :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,}"
                   @change="handleTableChange"
          >
            <template slot="action" slot-scope="text, record" >
              <a-button type="primary" v-if="record.status !== -1" @click="HandleStandard(record)">包装</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" v-if="record.status !== -1" @click="EditDi(record)">编辑</a-button>
              <a-divider type="vertical" />
              <a-popconfirm title="确定隐藏吗?" @confirm="() => myHandleDelete(record)">
                <a-button type="primary">隐藏</a-button>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a-button type="primary" v-if="record.declareStatus == 0 && record.status !== -1 " @click="myHandleCopyAdd(record)" >申报</a-button>
<!--              <a-divider v-if="record.declareStatus == 0 && record.status !== -1 " type="vertical" />-->
              <a-button type="primary" v-else-if="record.declareStatus == 1 && record.status !== -1 " @click="myHandleCopyAdd(record)">更新</a-button>
              <a-button disabled type="info" v-else-if="record.declareStatus == 2 && record.status !== -1 ">信息已提交</a-button>
              <a-button type="primary" v-else-if="record.declareStatus == 3 && record.status !== -1 " @click="myHandleCopyAdd(record)">更新</a-button>
              <a-button style="width: 116px" disabled type="info" v-else-if="record.declareStatus == -1 && record.status !== -1 ">未完善信息</a-button>
<!--              <a-button style="width: 116px" disabled type="info" v-else-if="record.codeSystem == 2">暂不支持申报</a-button>-->
              <a-divider v-if="record.jgState == '1'" type="vertical" />
             <a-button type="primary"  v-if="record.jgState == '1'" @click="uploadManage(record)">上传监管</a-button>
            </template>
            <template slot="declareStatus" slot-scope="declareStatus">
              <span v-if="declareStatus === -2">不允许申报</span>
              <span v-else-if="declareStatus === -1">资料未完善</span>
              <span v-else-if="declareStatus === 0">未申报</span>
              <span v-else-if="declareStatus === 1">已填报</span>
              <span v-else-if="declareStatus === 2">已提交</span>
              <span v-else-if="declareStatus === 3">待更新</span>
            </template>
            <template slot="codeSystem" slot-scope="codeSystem">
              <span v-if="codeSystem === '1'">MA(IDcode)</span>
              <span v-else-if="codeSystem === '2'">GS1</span>
              <span v-else-if="codeSystem === ''">MA(IDcode)</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <addDImodel v-if="showmodel" ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></addDImodel>
        <standardslistModel ref="standardModelref" @ok="modalFormOk" @close="modalFormClose"></standardslistModel>
        <reportModel ref="reportModelref" @ok="modalFormOk" @close="modalFormClose"></reportModel>
        <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
import standardslistModel from './modules/standardslistModel'
import addDImodel from './modules/addDImodel'
import reportModel from './modules/reportModel'
import ImportFileModal from '@/components/tools/ImportFileModal'
// import BillDetail from './dialog/BillDetail'
// import BillExcelIframe from '@/components/tools/BillExcelIframe'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { BillListMixin } from './mixins/BillListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { productDidel,asyncDiInfoApi } from '@/api/api'
import {getAction,getActionBlob } from '@/api/manage'
import { postAction } from '../../api/manage'

export default {
  name: 'RetailOutList',
  mixins: [JeecgListMixin, BillListMixin],
  components: {
    addDImodel,
    standardslistModel,
    reportModel,
    ImportFileModal,
    JEllipsis,
    JDate,
  },
  data() {
    return {
      showmodel:false,
      declareArr: [
        // 申报状态
        {
          label: '不允许申报',
          value: -2,
        },
        {
          label: '资料未完善',
          value: -1,
        },
        {
          label: '未申报',
          value: 0,
        },
        {
          label: '已填报',
          value: 1,
        },
        {
          label: '已提交',
          value: 2,
        },
      ],
      matype: [
        {
          label: 'MA码(IDcode)',
          value: '1',
        },
        {
          label: 'GS1',
          value: '2',
        }
      ],
      // 查询条件
      queryParam: {
        // beginTime: getNowFormatYear() + '-01-01',
        // endTime: moment().format('YYYY-MM-DD'),
        declareStatus: '',
        productDi: '',
        productName: '',
        specificationModel: '',
        releaseTime: ''
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认索引

      // 默认列
      columns: [
        { title: '产品编码-DI', width: '250px', dataIndex: 'productDi', ellipsis: true, },
        { title: '编码类型', width: '120px', dataIndex: 'codeSystem', scopedSlots: { customRender: 'codeSystem' } },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: '250px', 
        },
        
        { title: '规格型号', width: '150px', dataIndex: 'specificationModel', ellipsis: true },
        { title: '发布时间', width: '160px', dataIndex: 'releaseTime', },
        { title: '申报状态', width: '120px', dataIndex: 'declareStatus', scopedSlots: { customRender: 'declareStatus' } },
        { title: '申报时间', width: '160px', dataIndex: 'createTime', ellipsis: true },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'left',
          // width: 500,
          minWidth: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/productDi/list',
        delete: '/depotHead/delete',
        deleteBatch: '/depotHead/deleteBatch',
        deleteByIds: 'productDiV2/deleteDis',
        batchSetStatusUrl: '/depotHead/batchSetStatus',
        importExcelUrl: '/productDiV2/materials',
        exportXlsUrl: '/productDiV2/export',
      },
      selectedRowKeys: [],
      selectionRows: [],
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  created() {
    // this.initSystemConfig()
    this.initRetail()
    this.getDepotData()
    this.initUser()
    this.initAccount()
    window.onresize = () => {
      this.resetWidth()
    }
    this.resetWidth()
  },
  methods: {
      // 屏幕宽度变化是，监控table宽度，如超过1200，则设置为1200
      resetWidth() {
        let width = window.innerWidth
        if(width > 2050){
          this.columns[this.columns.length - 1].fixed = false
        }else{
          this.columns[this.columns.length - 1].fixed = 'right'
        }
      },
    // 下载模板
    // downloadModule() {
    //   location.href='http://fzudi.fangzhima.com/UDIImport.xlsx'
    // },
    // 下载说明
    downloadIntro() {
      location.href='https://fzudi.fangzhima.com/UDIImportDesc.xlsx'
    },
    // 导入
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = 'https://fzudi.fangzhima.com/UDIImport.xlsx'
      let templateName = '导入模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '商品导入'
    },
    //上传监管
    uploadManage(row){
      let that = this
      this.$confirm('是否确认上传监管?', '上传监管', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.loading = true
        getAction("/api/drugtrac/baseDrugUpload/",{diId:row.id, codeSystem:row.codeSystem}).then(res=>{
          if(res.code == 200){
            that.$message.success('上传成功')
          }else{
            that.$message.warning(res.message?res.message:'上传失败')
          }
          this.loading = false
          that.loadData(1)
        })
      }).catch((error) => {
        console.log(error)
        if(error!=='cancel'){
          that.$message.warning(error.message?error.message:"上传失败")
        }
      });
    },
    // 药监局申报
    myHandleCopyAdd(record) {
      this.$refs.reportModelref.add(record)
    },
    modalFormOk(){
      this.loadData()
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      console.log('selectedRowKeys', selectedRowKeys)
      console.log('selectionRows', selectionRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    // handleTableChange(pagination, filters, sorter) {
    //   this.ipagination = pagination
    //   this.loadData()
    // },
    // 下载
    async downloadDIs(){
      const params = {
        name: '导出产品DI',
        ex: '.xlsx',
      }
      this.handleExportXls(params)
    },
    // 批量删除
    handleDeleteBatch(){
      this.$confirm('是否确认删除选中项?', '删除选中项', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.loading = true
        postAction(this.url.deleteByIds,{ids:this.selectedRowKeys}).then(res=>{
          if(res.code == 200){
            this.$message.success('删除成功')
          }else{
            this.$message.warning(res.message||res.msg||'删除失败')
          }
          this.loading = false
          this.loadData()
        })
      }).catch((error) => {
        console.log(error)
        if(error!=='cancel'){
          this.$message.warning(error.message?error.message:"删除失败")
        }
      });
    },
    // 删除
    async myHandleDelete(record) {
      const res = await productDidel({ id: record.id })
      if (res.errno == 200 && res.errmsg == '成功') {
        this.$message.success('删除成功')
        this.loadData()
      } else {
        this.$message.error(res.data || res.errmsg)
      }
    },
    // 添加包装规格
    HandleStandard(record) {
      this.$refs.standardModelref.add(record)
    },
    gostandards() {},
    async asyncDiInfo(){
      let that = this
      const res = await asyncDiInfoApi({  })
      // this.$confirm({
      //   title: "提示",
      //   content: res.message,
      //   onOk: function () {
      //     that.searchQuery()
      //   }
      // })
      this.$confirm(res.message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.searchQuery()
      })

    },
    searchQuery(){
      console.log(this.queryParam,'搜索数据===================')
      this.loadData(this.queryParam)
    },
    // 注册DI
    myHandleAddDI() {
      const holdData = localStorage.getItem('holdData')
      this.showmodel = false
      this.$nextTick(()=>{
        this.showmodel = true
        this.$nextTick(()=>{
          if ( holdData ) {
            const newHoldData = JSON.parse(holdData) // 在接收端反序列化字符串回对象
            this.$refs.modalForm.add(newHoldData)
            this.$refs.modalForm.title = '新增产品DI'
          } else {
            this.$refs.modalForm.add()
            this.$refs.modalForm.title = '新增产品DI'
          }
        })
      })
    },
    EditDi(record) {
      debugger
      console.log(record,'编辑DI的数据==============================')
      this.showmodel = true
      this.$nextTick(()=>{
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '编辑产品DI'
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
